/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PalReauthSubmissionAdditionalForm } from './PalReauthSubmissionAdditionalForm';
import {
    PalReauthSubmissionAdditionalFormFromJSON,
    PalReauthSubmissionAdditionalFormFromJSONTyped,
    PalReauthSubmissionAdditionalFormToJSON,
    PalReauthSubmissionAdditionalFormToJSONTyped,
} from './PalReauthSubmissionAdditionalForm';
import type { PalReauthSubmissionDocumentSection } from './PalReauthSubmissionDocumentSection';
import {
    PalReauthSubmissionDocumentSectionFromJSON,
    PalReauthSubmissionDocumentSectionFromJSONTyped,
    PalReauthSubmissionDocumentSectionToJSON,
    PalReauthSubmissionDocumentSectionToJSONTyped,
} from './PalReauthSubmissionDocumentSection';

/**
 * 
 * @export
 * @interface PalReauthSubmissionDocumentList
 */
export interface PalReauthSubmissionDocumentList {
    /**
     * 
     */
    key_date_start?: string | null;
    /**
     * 
     */
    key_date_end?: string | null;
    /**
     * 
     */
    sections: Array<PalReauthSubmissionDocumentSection>;
    /**
     * Forms, such as the payer form, that go into the submission package right after the Concurrent Review Summary. Every form listed is included.
     */
    additional_forms: Array<PalReauthSubmissionAdditionalForm>;
}

/**
 * Check if a given object implements the PalReauthSubmissionDocumentList interface.
 */
export function instanceOfPalReauthSubmissionDocumentList(value: object): value is PalReauthSubmissionDocumentList {
    if (!('sections' in value) || value['sections'] === undefined) return false;
    if (!('additional_forms' in value) || value['additional_forms'] === undefined) return false;
    return true;
}

export function PalReauthSubmissionDocumentListFromJSON(json: any): PalReauthSubmissionDocumentList {
    return PalReauthSubmissionDocumentListFromJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalReauthSubmissionDocumentList {
    if (json == null) {
        return json;
    }
    return {
        
        'key_date_start': json['key_date_start'] === undefined ? undefined : json['key_date_start'] === null ? null : json['key_date_start'],
        'key_date_end': json['key_date_end'] === undefined ? undefined : json['key_date_end'] === null ? null : json['key_date_end'],
        'sections': ((json['sections'] as Array<any>).map(PalReauthSubmissionDocumentSectionFromJSON)),
        'additional_forms': ((json['additional_forms'] as Array<any>).map(PalReauthSubmissionAdditionalFormFromJSON)),
    };
}

export function PalReauthSubmissionDocumentListToJSON(json: any): PalReauthSubmissionDocumentList {
    return PalReauthSubmissionDocumentListToJSONTyped(json, false);
}

export function PalReauthSubmissionDocumentListToJSONTyped(value?: PalReauthSubmissionDocumentList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key_date_start': value['key_date_start'],
        'key_date_end': value['key_date_end'],
        'sections': ((value['sections'] as Array<any>).map(PalReauthSubmissionDocumentSectionToJSON)),
        'additional_forms': ((value['additional_forms'] as Array<any>).map(PalReauthSubmissionAdditionalFormToJSON)),
    };
}

